<nz-table
    #dataTable
    [nzSize]="size"
    [nzData]="data"
    id="stTable"
    [nzFrontPagination]="pagination"
    [nzLoading]="loading"
    [nzScroll]="data && data.length ? scroll : { x: scroll?.x }"
    class="st-table"
    (mouseleave)="changeMenuVisible(false)"
    [class]="resizeKey ? 'resize-table' : ''"
>
    <thead>
    <tr [hidden]="hiddenHead">
        <th *ngIf="hasEyes" nzWidth="30px" scope="col" class="head-eyes">
            <span nz-icon nzType="eye" nzTheme="outline" class="eyes-icon" [attr.data-id]="'resMgmt-eyeFilter'"
                  (mouseenter)="changeMenuVisible(true)"></span>
        </th>
        <th *ngIf="ifIndex" nzWidth="60px" scope="col"></th>
        <ng-container *ngFor="let column of columns; let i = index">
            <ng-container *ngIf="column.type === 'selection' && selectType !== 'single'; else thTemplate">
                <th
                    scope="col"
                    [nzWidth]="column?.realWidth || column.width"
                    [nzChecked]="checked"
                    [nzIndeterminate]="indeterminate"
                    (nzCheckedChange)="onAllChecked($event)"
                    [nzDisabled]="!resizeKey && column.disabled"
                    [nzMinWidth]="column?.dragMinWidth"
                    (nzResizeStart)="resizeStart($event, i)"
                    (nzResizeEnd)="resizeEnd($event, i)"
                >
                    <nz-resize-handle *ngIf="resizeKey" nzDirection="right" class="drag-trigger">
                        <div class="line"></div>
                    </nz-resize-handle>
                </th>
            </ng-container>
            <ng-template #thTemplate>
                <th
                    scope="col"
                    *ngIf="(!column.iif || column.iif(column))"
                    [nzWidth]="column?.realWidth || column.width"
                    [nzShowSort]="column.sort"
                    [nzSortFn]="column.sortFn"
                    [nzSortDirections]="column.sort"
                    [(nzSortOrder)]="column.sortOrder"
                    (nzSortOrderChange)="handleSort($event, column)"
                    [nzAlign]="column.nzAlign"
                    [nzFilters]="column.listOfFilter"
                    [nzFilterMultiple]="column.nzFilterMultiple"
                    [nzFilterFn]="column.nzFilterFn"
                    [class]="column.className + (resizeKey ? ' resize-cell' : '')"
                    [nzRight]="column.nzRight || false"
                    (nzFilterChange)="handleFilterChange($event, column)"
                    [nzCustomFilter]="column.customFilter"
                    class="header-cell"
                    nz-resizable
                    nzPreview
                    [nzDisabled]="!resizeKey"
                    [nzMinWidth]="column?.dragMinWidth"
                    (nzResizeStart)="resizeStart($event, i)"
                    (nzResizeEnd)="resizeEnd($event, i)"
                >
                    <div class="head-th-cell">
                        <div class="cell">
                            <i
                                    *ngIf="resizeKey && i === 0"
                                    nz-icon
                                    nz-tooltip="Reset Column Width"
                                    nzType="sync"
                                    class="close-icon resize-reset-icon"
                                    (click)="resetTablePosition(); $event.stopPropagation()"
                            ></i>
                            {{ column.title }}
                            <nz-filter-trigger
                                    *ngIf="column.customFilter"
                                    class="custom-filter"
                                    [nzActive]="column?.selectedValue"
                                    [nzVisible]="column.customFilter && column.filterVisible" (nzVisibleChange)="column.customFilter && (column.filterVisible = $event)"
                                    [nzDropdownMenu]="menu"
                            >
                                <i nz-icon nzType="filter" nzTheme="fill"></i>
                            </nz-filter-trigger>
                            <nz-dropdown-menu #menu="nzDropdownMenu">
                                <div class="ant-table-filter-dropdown">
                                    <div class="search-box">
                                        <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select" [(ngModel)]="column.selectedValue" (ngModelChange)="handleFilterChange(column?.selectedValue, column, i)">
                                            <nz-option *ngFor="let item of column.listOfFilter" [nzLabel]="item.label" [nzValue]="item.value"></nz-option>
                                        </nz-select>
                                    </div>
                                </div>
                            </nz-dropdown-menu>
                        </div>
                        <nz-resize-handle *ngIf="resizeKey" nzDirection="right" class="drag-trigger">
<!--                            <div class="line"></div>-->
                        </nz-resize-handle>
                    </div>
                </th>
            </ng-template>

        </ng-container>
    </tr>
    </thead>
    <tbody class="table-body" cdkDropList [cdkDropListDisabled]="!allowDrop" (cdkDropListDropped)="drop($event)">
    <tr *ngFor="let data of dataTable.data; let i = index; trackBy: trackByData" [ngClass]="getClassName(data, i)" cdkDrag
        class="st-font {{highlightId && data[rowKey] === highlightId ? 'click-row': ''}}" (click)="handleClickRow(data)">
        <td *ngIf="hasEyes" [nzAlign]="align"></td>
        <td *ngIf="ifIndex" [nzAlign]="align">{{ i + 1 }}</td>
        <ng-container *ngFor="let column of columns">
            <ng-container *ngIf="!column.iif || column.iif(column)">
                <ng-container *ngIf="!column.render; else render">
                    <ng-container [ngSwitch]="column.type">
                        <ng-container *ngSwitchCase="'selection'">
                            <td
                                *ngIf="shouldRender(column, data, i)"
                                [attr.colspan]="formatColSpan(column, data, i)"
                                [nzChecked]="setOfCheckedId.has(data[rowKey])"
                                [nzDisabled]="data.disabled"
                                [nzAlign]="column.nzAlign"
                                [class]="column.className"
                                [nzRight]="column.nzRight || false"
                                (nzCheckedChange)="onItemChecked(data[rowKey], $event)"
                            ></td>
                        </ng-container>

                        <ng-container *ngSwitchCase="'link'">
                            <td
                                *ngIf="shouldRender(column, data, i)"
                                [attr.colspan]="formatColSpan(column, data, i)"
                                [nzAlign]="column.nzAlign"
                                [class]="column.className"
                            >
                                <ng-container *ngIf="column.highlight; else linkTemplate">
                                    <a (click)="column.click(data)"
                                       [innerHTML]="getValueByPath(data, column.index, column, i) | highLight: keyword">
                                    </a>
                                </ng-container>

                                <ng-template #linkTemplate>
                                    <a (click)="column.click(data)">
                                        {{ getValueByPath(data, column.index, column, i) }}
                                    </a>
                                </ng-template>
                            </td>
                        </ng-container>

                        <ng-container *ngSwitchCase="'date'">
                            <td
                                *ngIf="shouldRender(column, data, i)"
                                [attr.colspan]="formatColSpan(column, data, i)"
                                [nzAlign]="column.nzAlign"
                                [class]="column.className"
                            >
                                {{ getValueByPath(data, column.index, column, i) | date: column.dateFormat }}
                            </td>
                        </ng-container>

                        <ng-container *ngSwitchDefault>
                            <td
                                *ngIf="shouldRender(column, data, i)"
                                [attr.colspan]="formatColSpan(column, data, i)"
                                [nzAlign]="column.nzAlign"
                                [class]="column.className"
                            >
                                <ng-container *ngIf="column.highlight; else textTemplate">
                                    <app-overflow-tooltip
                                        [text]="getValueByPath(data, column.index, column, i)"
                                        [html]="getValueByPath(data, column.index, column, i) | highLight: keyword"
                                    ></app-overflow-tooltip>
                                </ng-container>

                                <ng-template #textTemplate>
                                    <app-overflow-tooltip
                                        [text]="getValueByPath(data, column.index, column, i)"
                                    ></app-overflow-tooltip>
                                </ng-template>
                            </td>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-template #render>
                    <ng-container *ngIf="shouldRender(column, data, i)">
                        <td
                            [attr.colspan]="formatColSpan(column, data, i)"
                            [nzAlign]="column.nzAlign"
                            [class]="column.className"
                            [nzRight]="column.nzRight || false"
                        >
                            <ng-container
                                *ngTemplateOutlet="templates[column.render]; context: { $implicit: data, index: i, column: column }"></ng-container>
                        </td>
                    </ng-container>
                </ng-template>
            </ng-container>
        </ng-container>
    </tr>
    </tbody>
    <div *ngIf="menuVisible" class="head-menu" (mouseleave)="changeMenuVisible(false)"  (mouseenter)="changeMenuVisible(true)">
        <div class="menu-item first-item">
            <label
                nz-checkbox
                [(ngModel)]="allColumnsChecked"
                (ngModelChange)="updateColumnChecked()"
                [nzIndeterminate]="allColumnsIndeterminate"
                class="menu-label"
            >
                Show/Hide Columns
            </label>
        </div>
        <div class="column-content">
            <div *ngFor="let item of menuColumns; let i = index" class="menu-item">
                <label nz-checkbox [(ngModel)]="item.checked" (ngModelChange)="updateSingleColumnChecked()" class="menu-label">
                    {{ item.label || ''}}
                </label>
            </div>
        </div>
        <div class="apply-btn" class="menu-item last-item">
            <button nz-button nzType="primary" (click)="apply()" [nzLoading]="applyLoading">Apply</button>
        </div>
    </div>
</nz-table>

<div class="pagination-container">
    <nz-pagination
        *ngIf="page && page.show"
        [nzPageIndex]="pi"
        [nzTotal]="total"
        [nzPageSize]="ps"
        [nzShowTotal]="showTotal ? totalTemplate : null"
        [nzShowSizeChanger]="nzShowSizeChanger"
        [nzHideOnSinglePage]="nzHideOnSinglePage"
        (nzPageIndexChange)="handleSearch($event)"
        (nzPageSizeChange)="handleChangeSize($event)"
    ></nz-pagination>

    <ng-template
        #totalTemplate
        let-total
    >
        Total {{ total }}
    </ng-template>
</div>
